/** Value identified by looking at the difference in widths between the SVG element and its embedded Path element in the web inspector. */
export const addIconFudgeFactor = 12.2667 /*Path width*/ - 21 /*SVG width*/
